export default "__VITE_ASSET__D6nH4yT9__"